import styled from "styled-components";
import UserDetailsStyles from "./components/user_details/user_details.styles.jsx";
import PhoneValidationStyles from "./components/phone_validation/phone_validation.styles.jsx";

const PrimaryHomeHolderSC = styled.div`
    display: flex;
    flex-direction: row;
    height: 100vh;
    margin-top: 32px;
    position: absolute;
    width: 100%;
    top: 0;
    z-index: 10;

    user-select: "none";
    -webkit-user-select: none;
    -moz-user-select: node;
    -ms-user-select: none;

    input:-webkit-autofill,
    input:-webkit-autofill:hover,
    input:-webkit-autofill:focus,
    input:-webkit-autofill:active {
        -webkit-box-shadow: 0 0 0 1000px white inset !important;
        -webkit-text-fill-color: #333 !important; /* Your text color */
    }

    .context-holder {
        width: 55%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        z-index: 1;
        order: 1;
    }

    .card-holder {
        width: 45%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        z-index: 1;
        overflow: hidden;
        order: 2;
    }

    .content-card {
        background: white;
        border-radius: 30px;
        border: 2px solid #DDDAE6;
        width: 400px;
        height: 620px;
        padding: 32px;
        position: absolute;
        display: flex;
        flex-direction: column;

        transition: 
            margin 300ms ease,
            transform 300ms ease;
    }

    .card-1 { margin-left: 0px;  margin-top: 0px; z-index: 4; }
    .card-2 { margin-left: -16px; margin-top: -16px; z-index: 3; }
    .card-3 { margin-left: -32px; margin-top: -32px; z-index: 2; }
    .card-4 { margin-left: -48px; margin-top: -48px; z-index: 1; }

    .leaving {
        opacity: 0;
        transform: scale(0.96);
    }

    .next-button {
        background-color: #898989;
        width: 100% - 16px;
        height: 48px;
        display: flex;
        justify-content: center;
        align-items: center;
        color: white;
        font-size: 16px;
        border-radius: 16px;
        margin-top: 22px;
        font-weight: 600;

        &.loading {
            overflow: hidden;
            background: linear-gradient(
                90deg,
                #4FA44F 0%,
                #58B158 40%,
                #6BC96B 50%,
                #58B158 60%,
                #4FA44F 100%
            );
            background-size: 200% 100%;
            animation: shimmer 2s infinite linear;
            color: #00000000;
        }

        &.allowed {
            background-color: #2E9F3E;
            cursor: pointer;
        }

        @keyframes shimmer {
            0% {
                background-position: 200% 0;
            }
            100% {
                background-position: -200% 0;
            }
        }
    }

    .action-img {
        width: 100% - 16px;
        margin-top: 48px;
        height: 56px;
        cursor: pointer;
    }

    ${UserDetailsStyles}

    ${PhoneValidationStyles}

    @media (max-width: 640px) {
        flex-direction: column;
        height: unset;
        position: relative;

        .context-holder {
            width: 100%;
            align-items: unset;
            justify-content: unset;
            order: 2;
            margin-top: 640px;
        }

        .card-holder {
            width: 100%;
            order: 1;
            justify-content: unset;
            margin-top: 100px;
            margin-left: 12px;
        }

        .content-card {
            width: 70%;
            height: 450px;
        }

        .next-button {
            height: 32px;
            font-size: 14px;
            border-radius: 12px;
            margin-top: 14px;
            font-weight: 400;
        }

        .action-img {
            height: 36px;
        }
    }
`;

export default PrimaryHomeHolderSC;